const loadGoogleMapsApi = require('load-google-maps-api');
const $ = require("jquery");
const firebase = require('firebase/app');
require("firebase/database");
const baseUrl = require("../config.js").baseUrl;
const config = require("../config.js")
class GMap {
  constructor(id, cb){
    var that = this;
    that.cansatPos = {
      lat:0,
      lng:0
    };
    console.log("procceding to load maps");
    loadGoogleMapsApi({ key: config.mapsApiKey }).then(function () {
      that.map = new google.maps.Map(document.getElementById(id), {
        zoom: 4,
        center: that.cansatPos
      });

      cb();
    }).catch(function (e) {
      console.log(e);
    });

    that.markerList = {};
    that.markers = {};
  }

  _updateMarkers(){
    var that = this;
    Object.keys(that.markerList).forEach(function (marker_id) {
      let marker_info = that.markerList[marker_id];

      if(Date.now() - marker_info.timestamp <= 2 * 60 * 1000){
        if(typeof that.markers[marker_id] == "undefined"){
          that.markers[marker_id] = new google.maps.Marker({
            position: marker_info.position,
            map: that.map,
            icon: marker_info.icon,
            clickable: marker_info.clickable
          });
        } else {
          that.markers[marker_id].setPosition(marker_info.position);
          that.markers[marker_id].setMap(that.map);
        }
      } else {
        if(typeof that.markers[marker_id] != "undefined"){
          that.markers[marker_id].setMap(null);
        }
      }
    });
  }

  updateMarkers(markers){
    let that = this;
    that.markerList = Object.assign({}, that.markerList, markers);
  }

  setupRecoverMap(){
    let that = this;
    let locationRef = firebase.database().ref(baseUrl + 'location');
    locationRef.on('value', function(snapshot) {
      that.updateMarkers(snapshot.val());
    });
  }

  updateCansat(){
    let that = this;
    that.markerList["cansat"] = {};
    that.markerList["cansat"].position = that.cansatPos;
    //that.markerList["cansat"].icon = "./img/satellite-solid.svg"
    that.markerList["cansat"].timestamp = Date.now();
    that._updateMarkers();
    that.map.setCenter(that.cansatPos);

  }

  updateCansatLat(lat){
    let that = this;
    that.cansatPos.lat = lat;
    that.updateCansat();
  }

  updateCansatLng(lng){
    let that = this;
    that.cansatPos.lng = lng;
    that.updateCansat();
  }
}

module.exports = GMap;
